import './enableDisableParam.less'
import PopupConfirm from '../../../../../components/PopupConfirm/popupConfirm'
import { useReduxSelector } from '../../../../../hooks/useReduxSelector'
import {
  ACTION_POLICY_PARAMETERS_ENABLE_DISABLE,
  ACTION_POLICY_PARAMETERS_FETCH_BY_ID,
  enableDisablePolicyParameter,
  fetchPolicyParameterById,
  fetchPolicyParameters
} from '../../policySettingsSlice'
import { getActionState, getShowLoader, resetAction } from '../../../../../reducers/requestReducer'
import { STATES } from '../../../../../interfaces'
import { addNotification } from '../../../../notification/notificationSlice'
import LoaderView from '../../../../../components/Loader/loader'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Typography } from '@lightbeamai/design-system'
import { useDispatch } from 'react-redux'

const EnableDisableParam = ({
  param,
  onClose,
  isEnabled
}: {
  param?: string
  onClose: () => void
  isEnabled: boolean
}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const parameter = useReduxSelector(
    (state) => state.policySettings.policyParamerters.selectedPolicyParameter
  )

  useEffect(() => {
    if (param) {
      dispatch(fetchPolicyParameterById(param))
    }
  }, [param])

  const showLoader = useReduxSelector(() => getShowLoader(ACTION_POLICY_PARAMETERS_ENABLE_DISABLE))

  const fetchLoader = useReduxSelector(() => getShowLoader(ACTION_POLICY_PARAMETERS_FETCH_BY_ID))

  const enableDisableActionState = useReduxSelector(() =>
    getActionState(ACTION_POLICY_PARAMETERS_ENABLE_DISABLE)
  )

  const handleConfirm = () => {
    if (param && parameter) {
      dispatch(
        enableDisablePolicyParameter({
          ...parameter,
          enabled: !parameter.enabled
        })
      )
    }
  }

  useEffect(() => {
    if (enableDisableActionState === STATES.success) {
      dispatch(addNotification({ success: 'policy.settings.paramerters.enableDisable.success' }))
      onClose()
      dispatch(fetchPolicyParameters())
    } else if (enableDisableActionState === STATES.failed) {
      dispatch(addNotification({ error: 'policy.settings.paramerters.enableDisable.error' }))
    }
    resetAction(ACTION_POLICY_PARAMETERS_ENABLE_DISABLE)
  }, [enableDisableActionState, dispatch])

  const transKey = isEnabled ? 'disable' : 'enable'

  return (
    <PopupConfirm
      header={intl.formatMessage({ id: `policy.settings.paramerters.${transKey}.title` })}
      content={
        <>
          <LoaderView size="small" showLoader={fetchLoader} />
          <Typography type="medium">
            {intl.formatMessage({
              id: `policy.settings.paramerters.${transKey}.text_1`
            })}
          </Typography>
          <ul className="disable-attribute-list">
            <Typography as="li">
              {intl.formatMessage({
                id: `policy.settings.paramerters.${transKey}.text_2`
              })}
            </Typography>
          </ul>
        </>
      }
      confirmButton={intl.formatMessage({ id: `btn.${transKey}` })}
      className="disable-param-modal"
      open={!!param}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleConfirm}
      dismissible
      isLoading={showLoader}
    />
  )
}

export default EnableDisableParam
